import { useState } from 'react';

import Form from 'components/Form';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import { AccessTime } from '@mui/icons-material';
import { MobileTimePicker } from '@mui/x-date-pickers';

import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';

interface Props extends IFormRegister, IFormValues, IFormWatch {
  disabled?: boolean;
  blood: string;
}

const BloodInfo = (props: Props) => {
  const { blood, disabled, register, watch, setValue } = props;

  const rows = [
    { title: 'Mã só máu', variable: 'blood_number', type: 'text' },
    { title: 'Tên máu', variable: 'blood_name', type: 'text' },
    { title: 'Loại máu', variable: 'type', type: 'label' },
    { title: 'Lượng (ml)', variable: 'volume', type: 'text' },
    { title: 'Thời gian đến', variable: 'arrival_time', type: 'time' },
    {
      title: 'Thời điểm\nmáu đến',
      variable: 'blood_transfusion_arrival',
      type: 'text',
    },
    {
      title: 'Kiểm tra\ntruyền máu 1',
      variable: 'transfusion_check1',
      type: 'text',
    },
    {
      title: 'Kiểm tra\ntruyền máu 2',
      variable: 'transfusion_check2',
      type: 'text',
    },
    {
      title: 'Bắt đầu\ntruyền máu',
      variable: 'transfusion_start_time',
      type: 'time',
    },
    {
      title: 'Người thực hiện\n(lúc bắt đầu)',
      variable: 'practitioner_start',
      type: 'text',
    },
    {
      title: 'Kết thúc\ntruyền máu',
      variable: 'transfusion_end_time',
      type: 'time',
    },
    {
      title: 'Người  thực hiện\n(lúc kết thúc)',
      variable: 'practitioner_end',
      type: 'text',
    },
  ];

  return (
    <>
      <RowContainer xs={12} sx={{ marginTop: '-32px' }}>
        {rows.map(({ title, variable, type }) => (
          <RowContent
            key={variable}
            title={title}
            titleRatio={1}
            childrenRatio={2}
          >
            {type === 'text' && (
              <MuiTextField
                value={watch(`${variable}`)}
                onChange={e => setValue(variable, e.target.value)}
                required={false}
                disabled={disabled}
              />
            )}
            {type === 'label' && (
              <Form.MuiTextField
                disabled={disabled}
                value={blood}
                InputProps={{ readOnly: true }}
              />
            )}
            {type === 'time' && (
              <MobileTimePicker
                disabled={disabled}
                value={watch(`${variable}`) || null}
                onChange={value => setValue(variable, value)}
                renderInput={params => (
                  <MuiTextField
                    {...params}
                    required={false}
                    placeholder="00:00"
                    InputProps={{ endAdornment: <AccessTime /> }}
                    error={false}
                  />
                )}
              />
            )}
          </RowContent>
        ))}
      </RowContainer>
    </>
  );
};

export default BloodInfo;
